import { BlocksIconLocation } from 'blocks-nextjs/blocks-web-components/components/icon/icons/location';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconLocation = createComponent({ react: React, tagName: 'cat-icon-location', elementClass: BlocksIconLocation });
